<template>
    <section class="survey__row">
        <div class="survey__row__title"><span>{{ title }}</span></div>
        <div class="survey__row__container">
            <div class="survey__row__container__title" v-if="header">
                <span>{{ header }}</span>
            </div>
            <div class="survey__row__container__row points">
                <div class="survey__row__container__row__cell"></div>
                <div class="survey__row__container__row__cell">1</div>
                <div class="survey__row__container__row__cell">2</div>
                <div class="survey__row__container__row__cell">3</div>
                <div class="survey__row__container__row__cell">4</div>
                <div class="survey__row__container__row__cell">5</div>
            </div>
            <slot></slot>
        </div>
    </section>
</template>

<script>
export default {
    name: 'survey-row',
    props: {
        title: String,
        header: String
    }
}
</script>
